import { render, staticRenderFns } from "./OnboardingCredit.vue?vue&type=template&id=c170a760&"
import script from "./OnboardingCredit.vue?vue&type=script&lang=js&"
export * from "./OnboardingCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports